var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgFlowShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1384.91,
    height: 153,
    viewBox: "0 0 1384.91 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_804",
    x: 809,
    y: 93,
    width: 140,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_803",
    x: 520,
    y: 93,
    width: 100,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_782",
    x: 244,
    y: 93,
    width: 100,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_804-2",
    x: 1114,
    y: 93,
    width: 152,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1747",
    "data-name": "\\uADF8\\uB8F9 1747",
    transform: "translate(-213 -584)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 213, 584)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_804)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_804-3",
    "data-name": "\\uC0AC\\uAC01\\uD615 804",
    width: 140,
    height: 40,
    rx: 20,
    transform: "translate(809 93)",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uC6B4\\uC1A1\\uC7A5_\\uBC88\\uD638_\\uC785\\uB825",
    "data-name": "\\uC6B4\\uC1A1\\uC7A5 \\uBC88\\uD638 \\uC785\\uB825",
    transform: "translate(1099.909 702)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -45.836,
    y: 0
  }, "\uC6B4\uC1A1\uC7A5 \uBC88\uD638 \uC785\uB825")), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_138",
    "data-name": "\\uD0C0\\uC6D0 138",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(1037.909 691)",
    fill: "#50dc75"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 213, 584)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_803)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_803-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 803",
    width: 100,
    height: 40,
    rx: 20,
    transform: "translate(520 93)",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uBC30\\uC1A1_\\uB300\\uAE30",
    "data-name": "\\uBC30\\uC1A1 \\uB300\\uAE30",
    transform: "translate(791 702)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.942,
    y: 0
  }, "\uBC30\uC1A1 \uB300\uAE30")), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_137",
    "data-name": "\\uD0C0\\uC6D0 137",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(749 691)",
    fill: "#fe9f3f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 213, 584)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_782)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_782-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 782",
    width: 100,
    height: 40,
    rx: 20,
    transform: "translate(244 93)",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uC7AC\\uACE0_\\uD655\\uC778",
    "data-name": "\\uC7AC\\uACE0 \\uD655\\uC778",
    transform: "translate(515 702)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.942,
    y: 0
  }, "\uC7AC\uACE0 \uD655\uC778")), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_139",
    "data-name": "\\uD0C0\\uC6D0 139",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(473 691)",
    fill: "#ff5b5b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_639",
    "data-name": "\\uADF8\\uB8F9 639",
    transform: "translate(-2311.25 2252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_104",
    "data-name": "\\uD0C0\\uC6D0 104",
    transform: "translate(3829.16 -1595)",
    fill: "#00aab7",
    stroke: "#d5f0f2",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uBC30\\uC1A1_\\uC644\\uB8CC_\\uD655\\uC815",
    "data-name": "\\uBC30\\uC1A1 \\uC644\\uB8CC \\uD655\\uC815",
    transform: "translate(3869.16 -1566)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.096,
    y: 0
  }, "\uBC30\uC1A1"), /*#__PURE__*/React.createElement("tspan", {
    x: -12.096,
    y: 16
  }, "\uC644\uB8CC"), /*#__PURE__*/React.createElement("tspan", {
    x: -12.096,
    y: 32
  }, "\uD655\uC815"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_704",
    "data-name": "\\uADF8\\uB8F9 704",
    transform: "translate(-2188.23 -5514)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_826",
    "data-name": "\\uC0AC\\uAC01\\uD615 826",
    width: 72,
    height: 45,
    rx: 4,
    transform: "translate(3711 6101)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uC7AC_\\uBC30\\uC1A1",
    "data-name": "\\uC7AC \\uBC30\\uC1A1",
    transform: "translate(3747 6128)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.894,
    y: 0
  }, "\uC7AC \uBC30\uC1A1"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_700",
    "data-name": "\\uADF8\\uB8F9 700",
    transform: "translate(-2189.23 -5509)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_802",
    "data-name": "\\uC0AC\\uAC01\\uD615 802",
    width: 80,
    height: 52,
    rx: 4,
    transform: "translate(3581 6093)",
    fill: "#f65f8d"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uBC30\\uC1A1\\uC9C0\\uC5F0",
    transform: "translate(3621 6124)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.192,
    y: 0
  }, "\uBC30\uC1A1\uC9C0\uC5F0"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_698",
    "data-name": "\\uADF8\\uB8F9 698",
    transform: "translate(-2237.773 -5488)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_825",
    "data-name": "\\uC0AC\\uAC01\\uD615 825",
    width: 90,
    height: 52,
    rx: 4,
    transform: "translate(3435.682 6159)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uBC30\\uC1A1_\\uC911_\\uBC30\\uC1A1\\uCD9C\\uBC1C_",
    "data-name": "\\uBC30\\uC1A1 \\uC911 (\\uBC30\\uC1A1\\uCD9C\\uBC1C)",
    transform: "translate(3480.682 6182)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.894,
    y: 0
  }, "\uBC30\uC1A1 \uC911"), /*#__PURE__*/React.createElement("tspan", {
    x: -28.952,
    y: 16
  }, "(\uBC30\uC1A1\uCD9C\uBC1C)"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_697",
    "data-name": "\\uADF8\\uB8F9 697",
    transform: "translate(-2268.875 -5488)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_800",
    "data-name": "\\uC0AC\\uAC01\\uD615 800",
    width: 112,
    height: 52,
    rx: 4,
    transform: "translate(3141.875 6159)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uC0C1\\uD488_\\uC900\\uBE44_\\uC644\\uB8CC_\\uBC30\\uC1A1_\\uB300\\uAE30_",
    "data-name": "\\uC0C1\\uD488 \\uC900\\uBE44 \\uC644\\uB8CC (\\uBC30\\uC1A1 \\uB300\\uAE30)",
    transform: "translate(3197.875 6182)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -39.788,
    y: 0
  }, "\uC0C1\uD488 \uC900\uBE44 \uC644\uB8CC"), /*#__PURE__*/React.createElement("tspan", {
    x: -30.702,
    y: 16
  }, "(\uBC30\uC1A1 \uB300\uAE30)"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_696",
    "data-name": "\\uADF8\\uB8F9 696",
    transform: "translate(-2306.641 -5488)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_799",
    "data-name": "\\uC0AC\\uAC01\\uD615 799",
    width: 96,
    height: 52,
    rx: 4,
    transform: "translate(2903.64 6159)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uC0C1\\uD488_\\uC900\\uBE44\\uC911_\\uC7AC\\uACE0_\\uD655\\uC778_",
    "data-name": "\\uC0C1\\uD488 \\uC900\\uBE44\\uC911 (\\uC7AC\\uACE0 \\uD655\\uC778)",
    transform: "translate(2951.64 6182)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.99,
    y: 0
  }, "\uC0C1\uD488 \uC900\uBE44\uC911"), /*#__PURE__*/React.createElement("tspan", {
    x: -30.702,
    y: 16
  }, "(\uC7AC\uACE0 \uD655\uC778)"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_695",
    "data-name": "\\uADF8\\uB8F9 695",
    transform: "translate(-2335.766 -5488)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_798",
    "data-name": "\\uC0AC\\uAC01\\uD615 798",
    width: 84,
    height: 52,
    rx: 4,
    transform: "translate(2668.765 6159)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uC2E0\\uADDC_\\uC8FC\\uBB38",
    "data-name": "\\uC2E0\\uADDC \\uC8FC\\uBB38",
    transform: "translate(2710.765 6190)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.942,
    y: 0
  }, "\uC2E0\uADDC \uC8FC\uBB38"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_694",
    "data-name": "\\uADF8\\uB8F9 694",
    transform: "translate(-2319 -5488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_797",
    "data-name": "\\uC0AC\\uAC01\\uD615 797",
    transform: "translate(2532 6159)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 52,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 51,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uAD6C\\uB3C5_\\uACB0\\uC81C",
    "data-name": "\\uAD6C\\uB3C5 \\uACB0\\uC81C",
    transform: "translate(2572 6189)",
    fill: "#222",
    fontSize: 13,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.089,
    y: 0
  }, "\uAD6C\uB3C5 \uACB0\uC81C"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_623",
    "data-name": "\\uADF8\\uB8F9 623",
    transform: "translate(-3386.395 1737.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_706",
    "data-name": "\\uADF8\\uB8F9 706",
    transform: "translate(-3261.395 1737.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-2",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-2",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-2",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_707",
    "data-name": "\\uADF8\\uB8F9 707",
    transform: "translate(-3121.395 1737.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-3",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-3",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-3",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_708",
    "data-name": "\\uADF8\\uB8F9 708",
    transform: "translate(-2985.395 1737.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-4",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-4",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-4",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_709",
    "data-name": "\\uADF8\\uB8F9 709",
    transform: "translate(-2845.395 1737.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-5",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-5",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-5",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_710",
    "data-name": "\\uADF8\\uB8F9 710",
    transform: "translate(-2693.395 1737.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-6",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-6",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-6",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_711",
    "data-name": "\\uADF8\\uB8F9 711",
    transform: "translate(-2517.486 1737.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-7",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-7",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-7",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_733",
    "data-name": "\\uADF8\\uB8F9 733",
    transform: "translate(-2391.156 1737.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-8",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-8",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-8",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_712",
    "data-name": "\\uADF8\\uB8F9 712",
    transform: "translate(-2207.535 1650.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-9",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-9",
    "data-name": "\\uC120 89",
    y1: 44,
    transform: "translate(4.23 -10.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-9",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    transform: "translate(0 -14.26)",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_714",
    "data-name": "\\uADF8\\uB8F9 714",
    transform: "translate(1564.41 628.925) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-10",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(28.03 1.88) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-10",
    "data-name": "\\uC120 89",
    y1: 23.545,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-10",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604907989501953 7.019761562347412 L 0.85493004322052 7.019761562347412 L 4.229918956756592 1.019859194755554 L 7.604907989501953 7.019761562347412 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229918956756592 2.039709091186523 L 1.709856510162354 6.519761562347412 L 6.749980926513672 6.519761562347412 L 4.229918956756592 2.039709091186523 M 4.229918956756592 1.430511474609375e-06 L 8.4598388671875 7.519761562347412 L -9.5367431640625e-07 7.519761562347412 L 4.229918956756592 1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 213, 584)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_804-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_804-4",
    "data-name": "\\uC0AC\\uAC01\\uD615 804",
    width: 152,
    height: 40,
    rx: 20,
    transform: "translate(1114 93)",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uBC30\\uC1A1_\\uC644\\uB8CC\\uC2B9\\uC778_\\uC694\\uCCAD",
    "data-name": "\\uBC30\\uC1A1 \\uC644\\uB8CC\\uC2B9\\uC778 \\uC694\\uCCAD",
    transform: "translate(1410.909 702)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -51.884,
    y: 0
  }, "\uBC30\uC1A1 \uC644\uB8CC\uC2B9\uC778 \uC694\uCCAD")), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_140",
    "data-name": "\\uD0C0\\uC6D0 140",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(1342.909 691)",
    fill: "#9650dc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_734",
    "data-name": "\\uADF8\\uB8F9 734",
    transform: "translate(1301.24 604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_590",
    "data-name": "\\uD328\\uC2A4 590",
    d: "M.014,0V66.511s-1.084,18.01,15.6,18.01c4.922,0,71.509-.1,72.808-.1",
    transform: "translate(84.492 4.23) rotate(90)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_25",
    "data-name": "\\uB2E4\\uAC01\\uD615 25",
    transform: "translate(90.385 0) rotate(90)",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Button",
    transform: "translate(489 670)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Button")), /*#__PURE__*/React.createElement("text", {
    id: "Button-2",
    "data-name": "Button",
    transform: "translate(765 670)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Button")), /*#__PURE__*/React.createElement("text", {
    id: "Button-3",
    "data-name": "Button",
    transform: "translate(1074 670)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Button")), /*#__PURE__*/React.createElement("text", {
    id: "Button-4",
    "data-name": "Button",
    transform: "translate(1385 670)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Button")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFlowShipping);
export default __webpack_public_path__ + "static/media/img_flow_shipping.419d19e2cd4671777a4420174419b07b.svg";
export { ForwardRef as ReactComponent };